// ----------------------------------------------------------------------------
// Lightweight event bus for cross-component membership notifications
// Used so approval/denial actions on any page can tell NotificationBell to refresh
// ----------------------------------------------------------------------------

type Listener = () => void;

const listeners = new Set<Listener>();

/** Subscribe to membership change events. Returns an unsubscribe function. */
export const onMembershipChanged = (listener: Listener): (() => void) => {
  listeners.add(listener);
  return () => listeners.delete(listener);
};

/** Emit a membership change event — call this after approve/deny/cancel. */
export const emitMembershipChanged = () => {
  listeners.forEach((fn) => fn());
};
